module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": 3
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', {
    staticClass: "grey"
  }, [_c('div', {
    staticClass: "subHeader"
  }, [_vm._v(_vm._s(_vm.$t('message.gettingStartedGoalsSubHeader')))]), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": "",
      "id": "goalsSection"
    }
  }, _vm._l((_vm.lists.goals), function(item, index) {
    return _c('mu-col', {
      key: 'goal-' + index,
      staticStyle: {
        "margin-bottom": "16px"
      },
      attrs: {
        "desktop": "33",
        "tablet": "50",
        "width": "100"
      }
    }, [_c('mu-paper', {
      staticClass: "goalCard hvr-grow",
      staticStyle: {
        "width": "100%"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.updateGoal(item)
        }
      }
    }, [_c('mu-flexbox', {
      staticStyle: {
        "min-height": "44px"
      },
      attrs: {
        "align": "center center",
        "justify": "center center"
      }
    }, [_c('mu-flexbox-item', {
      staticStyle: {
        "margin-left": "8px !important",
        "margin-right": "8px"
      },
      attrs: {
        "align": "center",
        "grow": "0.5"
      }
    }, [_c('img', {
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "width": "40",
        "src": 'static/goals/' + item.icon + '.svg'
      }
    })]), _vm._v(" "), _c('mu-flexbox-item', {
      attrs: {
        "grow": "2"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.localizeGoal(item.goal)) + "\n                ")]), _vm._v(" "), _c('mu-flexbox-item', {
      staticClass: "layerBehind",
      attrs: {
        "grow": "1"
      }
    }, [_c('mu-checkbox', {
      key: 'goal-' + index,
      staticStyle: {
        "display": "flex",
        "float": "right",
        "margin-right": "8px"
      },
      attrs: {
        "checkedIcon": "check_circle",
        "uncheckIcon": "radio_button_unchecked",
        "color": "red"
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1)], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('mu-card-text', [(_vm.checkedGoals.length > 0) ? _c('div', [_c('h2', [_vm._v("\n            " + _vm._s(_vm.$t('message.gettingStartedGoalsWhenYouHave')) + "\n            "), _vm._l((_vm.checkedGoals), function(item, index) {
    return _c('span', {
      key: 'goals-checked-' + index
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(_vm.localizeGoal(item.plural) + (index === (_vm.checkedGoals.length) - 1 ? '...' : ''))
      }
    }), _vm._v(" "), (index < (_vm.checkedGoals.length - 2)) ? _c('span', {
      staticStyle: {
        "margin-left": "-2px"
      }
    }, [_vm._v(_vm._s(index < (_vm.checkedGoals.length - 2) ? ', ' : ''))]) : _vm._e(), _vm._v(" "), (index === (_vm.checkedGoals.length) - 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.andText')) + " ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "goalRelationTxt",
      "scroller": _vm.scroller,
      "data-vv-rules": 'required',
      "data-vv-name": "difference",
      "data-vv-value-path": "inputValue",
      "data-vv-as": "",
      "errorText": _vm.errors.first('difference'),
      "fullWidth": true,
      "label": _vm.$t('message.gettingStartedGoalsWhatDifference')
    },
    model: {
      value: (_vm.goalModel.goal_relation_id),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_relation_id", $$v)
      },
      expression: "goalModel.goal_relation_id"
    }
  }, _vm._l((_vm.lists.goal_relations), function(item, index) {
    return _c('mu-menu-item', {
      key: 'goal-id-' + index,
      attrs: {
        "value": item.goal_relation_id,
        "title": _vm.localizeGoalReason(item.title)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), (_vm.goalModel.goal_relation_id) ? _c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "goalTxt",
      "label": _vm.$t('message.gettingStartedGoalsWhenYouAreFeeling') + ' ' + _vm.loadRelationPlural(_vm.goalModel.goal_relation_id) + ' ' + _vm.$t('message.gettingStartedGoalsWhatWillYouNoticeIsDifferent'),
      "data-vv-rules": 'required',
      "data-vv-name": "reason",
      "data-vv-as": "",
      "data-vv-validate-on": "none",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('reason'),
      "hintText": _vm.$t('message.labelStartTyping'),
      "fullWidth": "",
      "rows": 3
    },
    model: {
      value: (_vm.goalModel.goal_text),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_text", $$v)
      },
      expression: "goalModel.goal_text"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mu-text-field-label",
    staticStyle: {
      "width": "100%",
      "font-size": "16px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.gettingStartedGoalsRatingScale')) + "\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "color": "black",
      "text-align": "right",
      "font-size": "18px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#0179d5"
    },
    domProps: {
      "textContent": _vm._s(_vm.goalModel.goal_evaluation)
    }
  }), _vm._v("/10\n            ")])]), _vm._v(" "), _c('mu-slider', {
    staticClass: "demo-slider",
    attrs: {
      "step": 1,
      "min": 0,
      "max": 10
    },
    model: {
      value: (_vm.goalModel.goal_evaluation),
      callback: function($$v) {
        _vm.$set(_vm.goalModel, "goal_evaluation", $$v)
      },
      expression: "goalModel.goal_evaluation"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": "",
      "secondary": "",
      "backgroundColor": "#9ACA3F",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "disabled": _vm.isSaving
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12596796","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GettingStarted/Goals.vue
// module id = 3056
// module chunks = 1